import { useSearchParams } from "react-router-dom";

import { LoginForm } from "@/pages/login/LoginForm";
import { useTranslations } from "@/lib/useTranslations";

export function LoginPage() {
  const [searchParams] = useSearchParams();
  const t = useTranslations("login");
  const redirectTo = searchParams.get("redirectTo") ?? undefined;
  const error = searchParams.get("error");

  return (
    <main className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center px-6 py-16">
      <div className="wireframe-border space-y-6 bg-whart-bg p-8">
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold tracking-tight text-whart-text">
            {t("title")}
          </h1>
          <p className="text-sm text-neutral-500">{t("subtitle")}</p>
        </div>

        {error === "unauthorized" ? (
          <p
            role="alert"
            className="wireframe-border px-3 py-2 text-sm text-whart-urgent"
          >
            {t("unauthorized")}
          </p>
        ) : null}

        {error === "inactive" ? (
          <p
            role="alert"
            className="wireframe-border px-3 py-2 text-sm text-whart-urgent"
          >
            {t("accountInactive")}
          </p>
        ) : null}

        {error === "auth_callback_failed" ? (
          <p
            role="alert"
            className="wireframe-border px-3 py-2 text-sm text-whart-urgent"
          >
            {t("authCallbackFailed")}
          </p>
        ) : null}

        <LoginForm redirectTo={redirectTo} />
      </div>
    </main>
  );
}
